import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";

@Directive({ standalone: false, selector: "[fxLayoutGap]" })
export class FxLayoutGapDirective implements OnChanges {
  @Input() fxLayoutGap?: string;
  constructor(private readonly host: ElementRef<HTMLElement>, private readonly renderer: Renderer2) {}
  ngOnChanges(_: SimpleChanges): void {
    const gap = (this.fxLayoutGap || "").trim();
    if (gap) this.renderer.setStyle(this.host.nativeElement, "gap", gap);
    else this.renderer.removeStyle(this.host.nativeElement, "gap");
  }
}
